import { ApiProperty } from "@nestjs/swagger";

export class palletLocationRequest {
    @ApiProperty()
    stockId: number;
    @ApiProperty()
    coldStorage:number;
    @ApiProperty()
    location:number;
    @ApiProperty()
    warehouseIncharge:string;
}
